import { all, call, put, take, takeLatest, throttle } from 'redux-saga/effects'
import fetchActionsName, { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import { fireToastError } from '../../actions/toasts/fireToast'
import i18n from '../../i18n'
import { IntegrationAction } from '../../reducers/airbnb/actionNames'
import fetchBookingIntegrationList from '../../models/Booking/fetchBookingIntegrationList'
import { IItemData } from '../../models/Booking'
import { getBookingRoomsSaga, getBookingSettingsSaga } from './booking'
import createBookingConnection from '../../models/Booking/createBookingConnection'
import saveBookingName from '../../models/Booking/saveBookingName'
import deleteBookingIntegration from '../../models/Booking/deleteBookingIntegration'
import unconfirmBookingIntegration from '../../models/Booking/unconfirmBookingIntegration'
import { RoomActions } from '../../reducers/bookingCalendar/actionNames'
import { PriceGridAction } from '../../reducers/price/actionNames'
import checkProperty from '../../models/Booking/checkProperty'
import confirmProperty from '../../models/Booking/confirmProperty'
import * as Effects from 'redux-saga/effects'
import { getBookingSettings } from '../../reducers/booking/selectors'

function* runFetchBookingMultiList() {
  try {
    const actionNames = fetchActionsName(ActionNames.fetchBookingMultiList)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(
        callFetch(
          actionNames.input,
          actionNames.output,
          fetchBookingIntegrationList,
        ),
      ),
    ])

    let bookingMulti: Array<IItemData> = yield call(service)

    if (!bookingMulti) {
      //console.error('bookingMulti is undefined')
      return
    }

    const updatedBookingMulti = yield call(
      processBookingMulti,
      bookingMulti as any,
    )

    yield put({
      type: 'FETCH_BOOKING_MULTI_SUCCESS',
      payload: updatedBookingMulti,
    })
  } catch (e) {
    // yield put(fireToastError(i18n.t('BED_3197_connect_window_error')))
    //console.error(e)
  }
}

const fetchBookingMulti = function* fetchBookingMulti() {
  yield* runFetchBookingMultiList()
}

function* bookingConnect(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.CreateBookingMulti)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(
        callFetch(
          actionNames.input,
          actionNames.output,
          createBookingConnection,
        ),
      ),
    ])

    let bookingMulti: Array<IItemData> = yield call(service, action.payload)

    const updatedBookingMulti = yield call(
      processBookingMulti,
      bookingMulti as any,
    )

    yield put({
      type: IntegrationAction.SetBookingPropertyModalStep,
      payload: 3,
    })
    // yield put({
    //   type: IntegrationAction.SetPropertyId,
    //   payload: {
    //     booking_id: action.payload.booking_property_id,
    //     subject: `Konfiguracja integracji Booking.com zgłoszona z Web App. Property id dla ${userEmail}`,
    //     body:
    //       `Property ID: ${action.payload.booking_property_id}\n` +
    //       `Property name: ${action.payload.booking_object_name}\n` +
    //       `User ID: ${userId}\n` +
    //       `Login: ${userEmail}\n\n`,
    //     recipient: 'support@bed-booking.com',
    //   },
    // })

    yield put({
      type: 'FETCH_BOOKING_MULTI_SUCCESS',
      payload: updatedBookingMulti,
    })
  } catch (e) {
    yield put(fireToastError(i18n.t('BED_3197_connect_window_error')))
    //console.error(e)
  }
}

function* processBookingMulti(bookingMulti) {
  if (bookingMulti === undefined) {
    return []
  }

  const tasks = bookingMulti.map(bookingMultiElement =>
    call(fetchBookingData, bookingMultiElement),
  )

  const updatedBookingMulti = yield all(tasks)

  return updatedBookingMulti
}

function* fetchBookingData(bookingMultiElement) {
  const [mappings, rooms] = yield all([
    call(getBookingSettingsSaga, { payload: bookingMultiElement.id } as any),
    call(getBookingRoomsSaga, { payload: bookingMultiElement.id } as any),
  ])

  return {
    ...bookingMultiElement,
    mappings: mappings.items.mappings,
    rooms: rooms.items,
  }
}

const changeBookingName = function* changeBookingName(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.SaveBookingMultiName)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, saveBookingName)),
    ])

    yield call(service, action.payload)
  } catch (e) {
    yield put(fireToastError(i18n.t('BED_3197_connect_window_error')))
    //console.error(e)
  }
}

const deleteConnect = function* deleteConnect(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.DeleteBookingMulti)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(
        callFetch(
          actionNames.input,
          actionNames.output,
          deleteBookingIntegration,
        ),
      ),
    ])

    yield call(service, action.payload)
  } catch (e) {
    yield put(fireToastError(i18n.t('BED_3197_connect_window_error')))
    //console.error(e)
  }
}

const unconfirm = function* unconfirm(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.DeleteBookingMulti)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(
        callFetch(
          actionNames.input,
          actionNames.output,
          unconfirmBookingIntegration,
        ),
      ),
    ])

    yield call(service, action.payload)
    yield put({ type: 'FETCH_BOOKING_MULTI' })
  } catch (e) {
    yield put(fireToastError(i18n.t('BED_3197_connect_window_error')))
    //console.error(e)
  }
}

function* checkBookingProperty(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.CheckBookingProperty)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, checkProperty)),
    ])

    const resp = yield call(service, action.payload.booking_property_id)

    if (resp && resp.exists === 0) {
      yield put({
        type: IntegrationAction.SetBookingPropertyValueTaken,
        payload: false,
      })
    }

    if (resp && resp.exists === 1) {
      yield put({
        type: IntegrationAction.SetBookingPropertyValueTaken,
        payload: true,
      })
    }

    if (!action.payload.conn) {
      if (resp && resp.connected === 1) {
        yield put({
          type: IntegrationAction.BookingConnect,
          payload: action.payload,
        })
      } else if (action.payload.async) {
        yield put({
          type: IntegrationAction.SetBookingPropertyModalStep,
          payload: 2,
        })
      }
    }

    yield put({
      type: IntegrationAction.SetBookingPropertyCheckLoading,
      payload: false,
    })
  } catch (e) {
    yield put(fireToastError(i18n.t('BED_3197_connect_window_error')))
    yield put({
      type: IntegrationAction.SetBookingPropertyCheckLoading,
      payload: false,
    })
    //console.error(e)
  }
}

function* startConfirmingProperty(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.ConfirmBookingProperty)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, confirmProperty)),
    ])

    const bookingSettings = yield Effects.select(getBookingSettings)

    const resp = yield call(service, bookingSettings.id)

    if (!!resp.items['connected']) {
      yield put({
        type: IntegrationAction.SetBookingPropertyModalConfirmStep,
        payload: 3,
      })
    } else {
      yield put({
        type: IntegrationAction.SetBookingPropertyModalConfirmStep,
        payload: 2,
      })
    }
  } catch (e) {
    // yield put(fireToastError(i18n.t('BED_3197_connect_window_error')))
    yield put({
      type: IntegrationAction.SetBookingPropertyModalConfirmStep,
      payload: 2,
    })
    //console.error(e)
  }
}

export default function*() {
  yield throttle(
    8000,
    ['FETCH_BOOKING_MULTI', RoomActions.RequestDataForRooms],
    fetchBookingMulti,
  )
  yield takeLatest(
    PriceGridAction.RefreshBookingIntegrationsForPriceGrid,
    runFetchBookingMultiList,
  )
  // yield takeLatest(RoomActions.RequestDataForRooms, fetchBookingMulti)
  yield takeLatest(IntegrationAction.BookingConnect, bookingConnect)
  yield takeLatest(IntegrationAction.ChangeBookingName, changeBookingName)
  yield throttle(2000, IntegrationAction.BookingDeleteProperty, deleteConnect)
  yield throttle(
    5000,
    IntegrationAction.UnconfirmBookingConfiguration,
    unconfirm,
  )
  yield takeLatest(IntegrationAction.CheckBookingProperty, checkBookingProperty)
  yield takeLatest(
    IntegrationAction.StartConfirmingProperty,
    startConfirmingProperty,
  )
}
